module.exports = __webpack_public_path__ + "static/img/10.4cf893e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/10.png
// module id = 1evg
// module chunks = 0